import { Route, Routes } from "react-router-dom";
import { UserRoles } from "../common/constants/UserRoles";
import {
  AppCategories,
  AppCategoryDetail,
  ListNotificationsMapping,
  ListPageUrlCategory,
  Login,
  PageNotFound,
  PageUrlDetail,
  States,
  TagDetail,
  Tags,
  Users
} from "../screen";
import PageUrl from "../screen/ListPageUrl";
import Protected from "./Protected";

const Router = () => {
  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route
        path="/"
        element={
          <Protected role={UserRoles.ADMIN}>
            <States />
          </Protected>
        }
      />
      <Route
        path="/users"
        element={
          <Protected role={UserRoles.ADMIN}>
            <Users />
          </Protected>
        }
      />
      <Route
        path="/tags"
        element={
          <Protected role={UserRoles.ADMIN}>
            <Tags />
          </Protected>
        }
      />
      <Route
        path="/tags/:appTagId"
        element={
          <Protected role={UserRoles.ADMIN}>
            <TagDetail />
          </Protected>
        }
      />
      <Route
        path="/app-category"
        element={
          <Protected role={UserRoles.ADMIN}>
            <AppCategories />
          </Protected>
        }
      />
      <Route
        path="/app-category/:appCategoryId"
        element={
          <Protected role={UserRoles.ADMIN}>
            <AppCategoryDetail />
          </Protected>
        }
      />
      <Route
        path="/notification-workflow-map"
        element={
          <Protected role={UserRoles.ADMIN}>
            <ListNotificationsMapping />
          </Protected>
        }
      />
        <Route
        path="/page-url-category"
        element={
          <Protected role={UserRoles.ADMIN}>
            <ListPageUrlCategory />
          </Protected>
        }
      />
        <Route
        path="/page-url"
        element={
          <Protected role={UserRoles.ADMIN}>
            <PageUrl />
          </Protected>
        }
      />
       <Route
        path="/page-url/:pageUrlId"
        element={
          <Protected role={UserRoles.ADMIN}>
            <PageUrlDetail />
          </Protected>
        }
      />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};

export default Router;
